import React from 'react';
import { Row } from 'antd';
import { TitleTabs } from './titleTabs';
import { DataLabel } from './dataLabel';
import { DataLabelStatus } from './dataLabelStatus';
import { anonimizarNome, anonimizarCpf } from '../../../helpers/utils';

export function LeftTab({ dataScreen }) {
  return <>
    <TitleTabs title="Motorista" dataScreen={dataScreen} />
    <Row
      span={24}
      style={{
        display: 'flex',
        justifyContent:
          dataScreen.codigoStatusMotorista !== 3 ? 'flex-end' : 'flex-start',
      }}
    >
      <DataLabel
        statusId={dataScreen.codigoStatusMotorista}
        title="Nome"
        label={anonimizarNome(dataScreen.nomeMotorista || '')}
      />
      <DataLabel
        statusId={dataScreen.codigoStatusMotorista}
        title="CPF"
        label={anonimizarCpf(
          dataScreen?.cpfMotorista?.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            '$1.$2.$3-$4'
          ) || ''
        )}
      />
      <DataLabelStatus
        title="Situação cadastral"
        statusId={dataScreen.codigoStatusMotorista}
        label={
          dataScreen.codigoStatusMotorista === 1
            ? 'Atualizado'
            : dataScreen.codigoStatusMotorista === 3
            ? 'Contato com a central'
            : 'Cadastro com pendência'
        }
      />
    </Row>
         </>;
}
